import styled from '@emotion/styled';
import { motion } from 'framer-motion';

const Grid = styled(motion.div)`
  display: grid;

  ${props =>
    props.winners
      ? `
    grid-template-rows: 0.8fr 2fr;
  `
      : `
    grid-template-rows: 1.2fr 2fr;
  `}

  height: calc(100% - 115px);
  width: 100%;

  align-items: center;
  justify-content: center;
  justify-items: center;
`;

export default Grid;
